var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.55 5H6.88333C5.63528 4.99999 4.43808 5.49463 3.55402 6.37558C2.66995 7.25652 2.1711 8.45196 2.16669 9.70001V29.7C2.16669 30.9509 2.66362 32.1506 3.54817 33.0352C4.43271 33.9197 5.63239 34.4167 6.88333 34.4167H33.55C34.798 34.4122 35.9935 33.9134 36.8744 33.0293C37.7554 32.1453 38.25 30.9481 38.25 29.7V9.70001C38.2456 8.45485 37.749 7.26195 36.8685 6.38148C35.9881 5.50101 34.7952 5.00439 33.55 5ZM5.06667 8.98336C5.21061 8.61912 5.46088 8.30668 5.7849 8.0867C6.10893 7.86672 6.49169 7.74936 6.88333 7.74999H33.55C33.9388 7.75269 34.3179 7.87156 34.6387 8.09133C34.9594 8.3111 35.2071 8.62176 35.35 8.98336V9.06667L20.1833 19.7H20.1L4.99999 9.11667L5.06667 8.98336ZM35.5 29.7C35.5 30.2187 35.2951 30.7165 34.9299 31.0848C34.5647 31.4531 34.0687 31.6623 33.55 31.6667H6.88333C6.36174 31.6667 5.86152 31.4595 5.4927 31.0906C5.12387 30.7218 4.91668 30.2216 4.91668 29.7V12.35L5.11667 12.4834L19.4166 22.4834C19.6567 22.6645 19.9492 22.7625 20.25 22.7625C20.5507 22.7625 20.8433 22.6645 21.0833 22.4834L35.5833 12.3333L35.5 29.7Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCampaign);
export default __webpack_public_path__ + "static/media/email-campaign.1679f2520f6674c0294b0780ad990b53.svg";
export { ForwardRef as ReactComponent };